/**
 * 消消看游戏路由组件
 * 直接启动消消看游戏，使用默认模式
 */

import React from 'react';
import { Match3Mode } from '../utils/match3';
import Match3Game from './Match3Game';

interface Match3RouterProps {
  onBackToMenu?: () => void;
  onBackToModeSelect?: () => void;
  initialMode?: Match3Mode;
}

const Match3Router: React.FC<Match3RouterProps> = ({
  onBackToMenu,
  onBackToModeSelect,
  initialMode = 'classic' // 默认使用经典模式
}) => {
  const handleBackToModeSelect = () => {
    // 直接调用父组件的 onBackToModeSelect
    if (onBackToModeSelect) {
      onBackToModeSelect();
    }
  };

  return (
    <Match3Game
      mode={initialMode}
      onBackToMenu={onBackToMenu}
      onBackToModeSelect={handleBackToModeSelect}
    />
  );
};

export default Match3Router;